<template>
  <div class="order-input-wrap">
    <base-tag label="复合适应症"></base-tag>
    <!-- 创建订单 - 复合适应症 - 选择按钮- 组件 -->
    <div class="composite" style="height: 60px;">
      <div class="input-label" style="width: 100px;margin-left: -4px;">
        <span style="color:red">*</span>
        <span>复合适应症</span>
      </div>
      <div class="composite-div">
        <div class="composite-box">
          <input ref="check-op1" type="checkbox" id="options-1" v-model="options1" class="custom-box"
            @change="checkChange(1,$event)"/>
          <label for="options-1" class="txt-label">
            上部种植修复冠
            <img class="select-icon" src="/static/images/order/catalog_sub/10_101_20_1.png">
          </label>
          <input ref="check-op2" type="checkbox" id="options-2" v-model="options2" style="margin-left: 7%;"
            class="custom-box" @change="checkChange(2,$event)"/>
          <label for="options-2" class="txt-label">
            {{ ['1010410'].includes(this.subCatalogId)?'马泷桥':'基台设计(金属)' }}
            <img class="select-icon" :src="getOptionsUrl">
          </label>
          <input ref="check-op3" type="checkbox" id="options-3" v-model="options3" style="margin-left: 7%;"
            class="custom-box" @change="checkChange(3,$event)" v-if="showOptions"/>
          <label for="options-3" class="txt-label" v-if="showOptions">
            基台设计(全瓷)
            <img class="select-icon" src="/static/images/order/catalog_sub/10_101_20_2_1.png">
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseTag from '/components/BaseTag'

export default {
  props: {
    subCatalogId: {
      type: String,
      default: ''
    },
    currentStep: {
      type: Number,
      default: ''
    },
  },
  data() {
    return {
      options1: false,
      options2: false,
      options3: false
    }
  },
  computed: {
    showOptions(){
      return ['1010120','1010210','1010220'].includes(this.subCatalogId);
    },
    getOptionsUrl(){
      let url = '/static/images/order/catalog_sub/';
      let str = ('1010410').includes(this.subCatalogId)?'10_101_20_3.png':'10_101_20_2.png';
      return url+str;
    }
  },
  methods: {
    checkChange(index,event) {
      const isChecked = event.target.checked;
      // 状态判断，两个基台不能同时选中
      if (index == 2 && this.options2) {
        this.options2 = true
        this.options3 = false
      } else if (index == 3 && this.options3) {
        this.options3 = true
        this.options2 = false
      }
      if(this.subCatalogId=='1010410'){
        if (index == 1) {
          this.options1 = isChecked;
          this.options2 = !isChecked;
        } else if (index == 2) {
          this.options2 = isChecked;
          this.options1 = !isChecked;
        }
      }
      this.setSession();
      // 连桥显示
      this.stateShow()
    },
    // 刷新后判断选中显示(复合适应症的复选框)
    stateShow() {
      var id = this.subCatalogId || ''
      // if (id == '1010410') {
      //   return false;
      // } else {
        if (this.currentStep == '2') {
          this.$nextTick(() => {
            if (this.options1) {
              this.$refs['check-op1'].setAttribute('class', "custom-checkbox")
            }
            if (this.options2) {
              this.$refs['check-op2'].setAttribute('class', "custom-checkbox")
            }
            if (this.options3) {
              this.$refs['check-op3'].setAttribute('class', "custom-checkbox")
            } else {
              return false;
            }
          })
        }
      // }
      this.$emit('handleIndication', this.options1, this.options2, this.options3)
    },
    // 复合式适应症选择option项
    choiceOptions(id) {
      // 下一步复合适应症选中当前的
      if (id == '1010120') {
        this.options1 = true
      } else if (id == '1010210') {
        this.options2 = true
      } else if (id == '1010220') {
        this.options3 = true
      } else if (id == '1010410') {
        this.options1 = true
        this.options2 = true
      }
      this.getSession();
      this.stateShow()
    },
    setSession(){
      sessionStorage.setItem('options1', JSON.stringify(this.options1));
      sessionStorage.setItem('options2', JSON.stringify(this.options2));
      sessionStorage.setItem('options3', JSON.stringify(this.options3));
    },
    getSession() {
      this.options1 = sessionStorage.getItem('options1') ? JSON.parse(sessionStorage.getItem('options1')):this.options1;
      this.options2 = sessionStorage.getItem('options2') ? JSON.parse(sessionStorage.getItem('options2')):this.options2;
      this.options3 = sessionStorage.getItem('options3') ? JSON.parse(sessionStorage.getItem('options3')):this.options3;
    },
  },
  mounted() {
    this.choiceOptions(this.subCatalogId);
  },
  components: {
    BaseTag
  },
}
</script>
<style lang="scss" scoped>
.composite {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-left: 2.2%;
  font-size: 13px;
  position: relative;
  font-family: "宋体", Arial, sans-serif;
}

.order-input-wrap {
  width: 100%;
  position: relative;
}

.input-radio-box,
.composite-box {
  width: 80%;
  height: 32px;
  padding-left: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
}

.composite-div {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
}

/* 自定义复选框样式 */
.custom-checkbox,
.custom-box {
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #ccc;
  position: relative;
  margin-right: 8px;
}

.select-icon {
  width: 35px;
  height: 35px;
  position: absolute;
  margin-left: 12px;
  top: 18%;
}

.txt-label {
  width: 140px;
  margin-left: 5px;
  background-color: #F7F7F7;
}

.txt-label:hover {
  cursor: pointer;
}

/* 自定义复选框样式 */
.custom-checkbox,
.custom-box {
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #ccc;
  position: relative;
  margin-right: 8px;
}

/* 当复选框选中时的样式 */
.custom-checkbox:checked::before {
  content: '';
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 5px solid #00A5D5;
  margin: -1px;
}

.custom-checkbox:hover {
  border: 1px solid #00A5D5;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// selIndication.vue?7914b39e